import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import {
  ComponentEntity,
  Entity,
  RELATION_HAS_PART,
  RELATION_OWNER_OF,
} from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasComponentsCardProps {
  variant?: InfoCardVariants;
}

export const HasComponentsCard = (props: HasComponentsCardProps) => {
  function relationType(entity: Entity): string {
    if (entity.kind === 'Group') {
      return RELATION_OWNER_OF;
    }
    return RELATION_HAS_PART;
  }

  const { variant = 'gridItem' } = props;
  const { entity } = useEntity();

  const resourceEntityColumns: TableColumn<ComponentEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
    EntityTable.columns.createSpecTypeColumn(),
    EntityTable.columns.createSpecLifecycleColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
  ];

  const asResourceEntities = (entities: Entity[]): ComponentEntity[] =>
    entities as ComponentEntity[];

  return (
    <RelatedEntitiesCard
      variant={variant}
      title="Components"
      entityKind="Component"
      relationType={relationType(entity)}
      columns={resourceEntityColumns}
      asRenderableEntities={asResourceEntities}
    />
  );
};
